import React, { FC } from 'react';

import { useMessage } from '../../../../context/messages/useMessage';
import { MessagesModalPreviewSendToView } from './MessagesModalPreviewSendToView';

export const MessagesModalPreviewSendTo: FC = () => {
  const {
    staff,
    staffCriteria,
    parentsCriteria,
    parentsByIndividualStudent,
    parents,
    staffByIndividualStudent,
    criteriaDate,
  } = useMessage();

  return (
    <MessagesModalPreviewSendToView
      staff={staff}
      staffCriteria={staffCriteria}
      staffByIndividualStudent={staffByIndividualStudent}
      parents={parents}
      parentsCriteria={parentsCriteria}
      parentsByIndividualStudent={parentsByIndividualStudent}
      criteriaDate={criteriaDate}
    />
  );
};
